import { FieldValidator } from "./"

export const validatePasswordFormat: FieldValidator = value => {
  const PASSWORD_REGEXP = /^(?=.*[^a-zA-Z0-9]+).{8,}/
  let error = null

  if (value && !value.match(PASSWORD_REGEXP)) {
    error = "Your password must be at least 8 characters including one special character."
  }

  return error
}
